import fetcher from 'api/fetcher';
import { DISABLE_OFF_SOURCES } from 'utils/constants/campaign';
import { formatDate } from 'utils/date';

import urlParser from 'bloko/common/urlParser';

import {
    setStatisticsByDates,
    setStatisticsHeaders,
    setStatisticsLoad,
    setStatisticsShowResponsesAndCr,
    setStatisticsUsedSubSources,
    STATISTICS_INITIAL_STATE,
} from 'store/models/statistics';

export const getStatisticsMethod = ({ from, to, bannerId, campaignId, type = null }) => {
    const path = bannerId ? `banner/${bannerId}` : `campaign/${campaignId}`;
    const params = {
        dateFrom: formatDate(from),
        dateTo: formatDate(to),
    };
    if (type) {
        params.type = type;
    }
    const queryStr = urlParser.stringify(params);
    return `/api/v1/statistics/${path}/?${queryStr}`;
};

export default () => {
    return (dispatch, getState) => {
        const { from, to, bannerId, campaignId } = getState().statistics;
        dispatch(setStatisticsLoad(true));
        return fetcher
            .get(getStatisticsMethod({ from, to, bannerId, campaignId }))
            .then((statistics) => {
                const { usedSubSources, total } = statistics;
                const currentSources = total?.data;
                const headers = currentSources ? [...Object.keys(currentSources)] : [];
                if (currentSources) {
                    DISABLE_OFF_SOURCES.forEach((source) => {
                        if (Object.keys(currentSources).includes(source)) {
                            headers.push(source);
                        }
                    });
                }
                dispatch([
                    setStatisticsUsedSubSources(usedSubSources),
                    setStatisticsHeaders(headers),
                    setStatisticsByDates(statistics || STATISTICS_INITIAL_STATE.items),
                    setStatisticsShowResponsesAndCr(false),
                    setStatisticsLoad(false),
                ]);
            })
            .catch(() => {
                dispatch([setStatisticsByDates(STATISTICS_INITIAL_STATE.items), setStatisticsLoad(false)]);
            });
    };
};
